import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, OnChanges, SimpleChanges, Renderer2 } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { NgIf, NgClass } from '@angular/common';
import { NiButtonComponent } from '../ni-button/ni-button.component';
import { NiIconComponent } from '../ni-icon/ni-icon.component';

@Component({
  selector: 'NiFormModal',
  standalone: true,
  imports: [NgIf, NgClass, NiButtonComponent,NiIconComponent],
  templateUrl: './ni-modal.component.html',
  animations: [
    trigger('backdropAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms ease-in-out', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate('300ms ease-in-out', style({ opacity: 0 }))
      ])
    ]),
    // Modal content animation: slide from bottom to center
    trigger('modalAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(100%)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ opacity: 0, transform: 'translateY(100%)' }))
      ])
    ])
  ]
})

export class NiModalComponent implements OnInit, OnDestroy, OnChanges {
  @Input() isOpen: boolean = false;
  @Input() isMobile: boolean = false;
  @Input() title: string = '';
  @Input() className: string = '';
  @Input() hasBackdrop: boolean = true;
  @Input() showCancelIcon: boolean = true;
  @Input() showDeleteIcon: boolean = true;
  @Input() preventBackdropClose: boolean = false; // Prevent closing on backdrop click or Escape key
  @Output() onClose = new EventEmitter<void>();
  @Output() deletedData = new EventEmitter<void>();
  
  @Input() showActions = false;
  @Input() cancelText = 'Cancel';
  @Input() confirmText = 'Confirm';
  
  @Output() closed = new EventEmitter<void>();
  @Output() confirmed = new EventEmitter<void>();
  
  
  private originalPaddingRight: string = '';
  private escapeListener: () => void = () => {};

  constructor(private readonly renderer: Renderer2) {}

  ngOnInit(): void {
    // Listen for Escape key presses
    this.escapeListener = this.renderer.listen('window', 'keydown', (event: KeyboardEvent) => {
      if (event.key === 'Escape' && this.isOpen && !this.preventBackdropClose) {
        this.close();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen']) {
      if (this.isOpen) {
        // Calculate scrollbar width and apply body style changes
        const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
        this.originalPaddingRight = document.body.style.paddingRight;
        document.body.style.overflow = 'hidden';
        document.body.style.paddingRight = `${scrollBarWidth}px`;
      } else {
        // Restore body styles when modal is closed from the parent
        this.restoreBodyStyles();
      }
    }
  }

  ngOnDestroy(): void {
    if (this.escapeListener) {
      this.escapeListener();
    }
    // Ensure body styles are restored if component is destroyed while open
    if (this.isOpen) {
      this.restoreBodyStyles();
    }
  }

  close(): void {
    this.isOpen = false;
    this.restoreBodyStyles();
    this.onClose.emit();
  }

  private restoreBodyStyles(): void {
    document.body.style.overflow = '';
    document.body.style.paddingRight = this.originalPaddingRight;
  }
  confirm() {
    this.confirmed.emit();
    this.close();
  }

  delete(){
    this.deletedData.emit()
    this.close();
  }
}